import { Injectable } from '@angular/core';
import { DataTableEditorService } from '../../../../shared/search/results/data-table-editor.service';
import { PickManagementBackendService } from './pick-management-backend.service';
import { PickManagementDataService } from './pick-management-data.service';
import { SharedServiceRegistry } from '../../../../shared/shared-service-registry';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { DetailedEntityDataEditorService } from '../../../../shared/services/searchable-entity/detailed-entity/detailed-entity-data-editor.service';
import { HttpStatusCode } from 'app/shared/models/http-status-code.constants';
import { COMMONPROPERTIES } from 'app/shared/models/common-fields';
import { SearchEvent } from 'app/shared/search/models/search-event';
import { REFRESH_SEARCH_EVENT } from 'app/shared/search/search-constants';
import { CASE_ID_CONFIG_KEY, TABLE_NAME } from 'app/constants';


@Injectable()
export class PickManagementDataEditorService extends DetailedEntityDataEditorService {
  public backendService: PickManagementBackendService;
  public dataService: PickManagementDataService;
  private channelId: any;
  public isCaseIDEditable: boolean;

  constructor(protected coreServiceRegistry: CoreServiceRegistry,
    protected sharedServiceRegistry: SharedServiceRegistry) {
    super(coreServiceRegistry, sharedServiceRegistry);
  }

  public setDependentServices(dataService, backendService) {
    this.dataService = dataService;
    this.backendService = backendService;
  }

  /**
   * This method handles the changes to the property value
   * @param event - Property Change Event
   */
  public propertyValueChanged(): boolean {
    return true;
  }
  /**
   * This method is used to refresh the cells of the table
   * @param params - cell params
   */
  public refreshCells(params: any) {
    params.api.refreshCells({ rowNodes: [params.node] });
  }
  // LFWM-3557- adding validation to orderLineNo
  public validateOrderLineNo(currentRow: any, propertyName: any, gridOptions: any) {
    let currentRowCells = currentRow.cells;
    const currentCell = gridOptions.api.getFocusedCell();
    let orderKey = currentRowCells['orderKey'].cVal;
    let orderLineNo = currentRowCells['orderLineNo'].cVal;
    const colId = currentCell.column.colId;
    this.backendService.validateOrderLineNo(orderKey, orderLineNo)
      .subscribe((resp: any) => {
        if (resp['statusCode'] && resp['statusMessage']) {
          if (resp['statusCode'] === 200 && resp['statusMessage'] === 'SUCCESS') {
            currentRowCells[propertyName].isValueInvalid = false;
            gridOptions.api.stopEditing();
            gridOptions.api.clearFocusedCell();
            gridOptions.api.startEditingCell({
              rowIndex: currentCell.rowIndex + 1,
              colKey: colId
            });
            gridOptions.api.setFocusedCell(currentCell.rowIndex + 1, colId);
          } else if (resp['statusCode'] === 400 && resp['statusMessage'] === 'FAILURE') {
            currentRowCells[propertyName].isValueInvalid = true;
            this.alertService.clearAll();
            const errorResp = this.resourceService.get('msg_the_order') + orderKey + ' ' + this.resourceService.get('msg_and_orderLine') + orderLineNo + ' ' + this.resourceService.get('tps_errmsg1');
            this.alertService.clearAll().error(errorResp);
            gridOptions.api.stopEditing();
            gridOptions.api.clearFocusedCell();
            gridOptions.api.startEditingCell({
              rowIndex: currentCell.rowIndex,
              colKey: colId
            });
            gridOptions.api.setFocusedCell(currentCell.rowIndex, currentCell.column.colId);
          }
        }
      }, (error) => {
        this.alertService.clearAll().error(this.resourceService.get(error));
      });
  }
  /**
   * handleMultiColumnPopupEvent
   */
  // LFWM-3557- overridden this method to initialize value of orderLineNo isValueInvalid as false.
  public handleMultiColumnPopupEvent(event: any, property: string, currentRow: any) {
    //LFWM-4131- get channel id based on channel, sku,lot, facility
    const columnKey = Object.keys(event.selectedItems);
    if (columnKey.indexOf('orderLineNo') > -1) {
      currentRow.cells['lot'].cVal = '';
      currentRow.cells['loc'].cVal = '';
      currentRow.cells['id'].cVal = '';
      currentRow.cells['orderLineNo'].cVal = event.selectedItems['orderLineNo'];
      currentRow.cells['orderLineNo'].isEdited = true;
      currentRow.cells['orderLineNo'].isValueInvalid = false;
      currentRow.cells['commodity'].cVal = event.selectedItems['commodity'];
      currentRow.cells['commodity'].isEdited = true;
      currentRow.cells['storerKey'].cVal = event.selectedItems['storerKey'];
      currentRow.cells['storerKey'].isEdited = true;
      currentRow.cells['facility'].cVal = event.selectedItems['facility'];
      currentRow.cells['facility'].isEdited = true;
      currentRow.cells['packKey'].cVal = event.selectedItems['packKey'];
      currentRow.cells['packKey'].isEdited = true;
      currentRow.isEdited = true;
    }
    if (columnKey.indexOf('lot') > -1) {
      currentRow.cells['loc'].cVal = '';
      currentRow.cells['loc'].isEdited = true;
      currentRow.cells['id'].cVal = '';
      currentRow.cells['id'].isEdited = true;
      currentRow.cells['lot'].cVal = event.selectedItems['lot'];
      currentRow.cells['lot'].isEdited = true;
      currentRow.isEdited = true;
    }
    if (columnKey.indexOf('loc') > -1) {
      currentRow.cells['id'].cVal = '';
      currentRow.cells['id'].isEdited = true;
      currentRow.cells['loc'].cVal = event.selectedItems['loc'];
      currentRow.cells['loc'].isEdited = true;
      currentRow.isEdited = true;
    }
    if (columnKey.indexOf('id') > -1) {
      currentRow.cells['id'].cVal = event.selectedItems['id'];
      currentRow.cells['id'].isEdited = true;
      currentRow.isEdited = true;
    }
    this.changeDisplayType(currentRow);
    // [UWP-49431] Hedwig Alert-/api/outbound/pick/channelid- 500 Error| global change
    // Move to below to avoid empty values
    this.getChannelId(event, currentRow);

  }

  private changeDisplayType(currentRow){
    this.dataService.searchServices[0].getMetadata().columnList.forEach(col=>{
      if(col.propertyName === COMMONPROPERTIES.CHANNELID)
        col.displayType = COMMONPROPERTIES.DISPLAY_MODE.VIEW;
    });
  }


  private isFieldValid(value: string): boolean {
    return value && value !== ' ' && value !== '' && value.trim() !== '';
  }

  private getCurrentRowValue(currentRow: any, fieldName: string): string {
    return currentRow && currentRow.cells && currentRow.cells[fieldName] ? currentRow.cells[fieldName].cVal : null;
  }

  private getChannelId(event, currentRow){
    // Guard: check if event and event.selectedItems exist
    if (event && event.selectedItems) {

    // [UWP-49431] Hedwig Alert-/api/outbound/pick/channelid- 500 Error| global change
    // Fallback to currentRow values if not present in event.selectedItems to avoid empty values being sent to backend which causes 400 error. This can happen when user changes orderLineNo and then changes lot without changing orderLineNo again. In this case event.selectedItems will have lot value but not orderLineNo value.
    event.selectedItems[COMMONPROPERTIES.CHANNEL] = event.selectedItems[COMMONPROPERTIES.CHANNEL] || this.getCurrentRowValue(currentRow, COMMONPROPERTIES.CHANNELID);
    event.selectedItems[COMMONPROPERTIES.COMMODITY] = event.selectedItems[COMMONPROPERTIES.COMMODITY] || this.getCurrentRowValue(currentRow, COMMONPROPERTIES.COMMODITY);
    event.selectedItems[COMMONPROPERTIES.STORER_KEY] = event.selectedItems[COMMONPROPERTIES.STORER_KEY] || this.getCurrentRowValue(currentRow, COMMONPROPERTIES.STORER_KEY);
    event.selectedItems[COMMONPROPERTIES.FACILITY] = event.selectedItems[COMMONPROPERTIES.FACILITY] || this.getCurrentRowValue(currentRow, COMMONPROPERTIES.FACILITY);
    event.selectedItems[COMMONPROPERTIES.LOT] = event.selectedItems[COMMONPROPERTIES.LOT] || this.getCurrentRowValue(currentRow, COMMONPROPERTIES.LOT);

      // Use captured row reference instead of focusedRow to avoid timing issues
      const targetRow = currentRow;
      this.backendService.getChannelId(event).subscribe(
        (res: any) => {
          // [UWP-49431] Hedwig Alert-/api/outbound/pick/channelid- 500 Error| global change
          // add check if status code is 400 and show error message even httpstatus is 200
          if (res.statusCode === HttpStatusCode.badRequest) {
            this.alertService
              .clearAll()
              .error(this.resourceService.get(res.statusMessage));
            return;
          }
          this.channelId = res.channelId;
          // Use captured row reference instead of focusedRow to avoid timing issues
          if (targetRow && targetRow.cells && targetRow.cells[COMMONPROPERTIES.CHANNELID]) {
            targetRow.cells[COMMONPROPERTIES.CHANNELID].cVal = this.channelId;
            targetRow.cells[COMMONPROPERTIES.CHANNELID].isEdited = true;
            // Trigger UI refresh
            if (this.dataService.searchServices && this.dataService.searchServices[0]) {
              this.dataService.searchServices[0].publishEvent(new SearchEvent(REFRESH_SEARCH_EVENT));
            }
          }
        },
        // [UWP-49431] Hedwig Alert-/api/outbound/pick/channelid- 500 Error| global change
        // add check if status code is not 200
        (error) => {
          this.alertService
            .clearAll()
            .error(this.resourceService.translateServerResponse(error));
        },
      );
    } else {
      const focusedRow = this.dataService.searchServices[0].getPagedData().focusedRow;
      if (focusedRow && focusedRow.cells &&
          focusedRow.cells[COMMONPROPERTIES.CHANNELID] &&
          focusedRow.cells[COMMONPROPERTIES.CHANNELID].cVal === undefined) {
        focusedRow.cells[COMMONPROPERTIES.CHANNELID].cVal = 0;
        focusedRow.cells[COMMONPROPERTIES.CHANNELID].isEdited = true;
      }
    }

  }

  public async getIfCaseIDIsEnabled(storerKey: string, facilityKey: string) {
    return await this.backendService.getStorerConfigurationForFacility(facilityKey, storerKey, CASE_ID_CONFIG_KEY, TABLE_NAME.PICK_TD).toPromise();
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/outbound/pick-management/services/pick-management-editor.service.ts